import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import {
    PersonalDetailsEndpoints,
    PersonalDetailsInfo,
    PersonalDetailsState,
} from './personalDetailsTypes';
import { initialStatePersonalDetails as initialState } from './personalDetailsDefaultValue';
import { ApiStatus } from '../../types';

const personalDetailsSlice = createSlice({
    name: 'personalDetails',
    initialState,
    reducers: {
        personalDetailsSubmit: (state) => state,
        personalDetailsContactsEdit: (state) => state,
        updatePersonalDetailsEndpoints: (state, action: PayloadAction<PersonalDetailsEndpoints>) => {
            state.apiEndpoints = action.payload;
        },
        getPersonalDetails(state) {
            state.getPersonalDetailsApiStatus = ApiStatus.Pending;
        },
        getPersonalDetailsFulfilled(state, action: PayloadAction<PersonalDetailsInfo>) {
            const { content, address, mobileNumber, email, isResident, driverLicenceNumber } = action.payload;

            state.getPersonalDetailsApiStatus = ApiStatus.Fulfilled;
            state.personalInfo = { ...state.personalInfo, address, mobileNumber, email, isResident, driverLicenceNumber };
            state.content = JSON.parse(content);
        },
        getPersonalDetailsRejected(state) {
            state.getPersonalDetailsApiStatus = ApiStatus.Rejected;
        },
        deletePersonalDetails(state) {
            state.deletePersonalDetailsApiStatus = ApiStatus.Pending;
        },
        deletePersonalDetailsFulfilled(state) {
            state.deletePersonalDetailsApiStatus = ApiStatus.Fulfilled;
        },
        deletePersonalDetailsRejected(state) {
            state.deletePersonalDetailsApiStatus = ApiStatus.Rejected;
        },
        resetPersonalDetailsStatus(state) {
            state.getPersonalDetailsApiStatus = ApiStatus.Idle;
            state.deletePersonalDetailsApiStatus = ApiStatus.Idle;
        },
        updateCheckboxState(state, action: PayloadAction<{ name: string, value: boolean }>) {
            const { name, value } = action.payload;

            state.checkboxStates[name] = value;
        },

        openResidencyEditMode(state) {
            state.isResidencyEditMode = true;
        },
        cancelResidencyEditMode(state) {
            state.isResidencyEditMode = false;
        },
        updateResidencyState(state, action: PayloadAction<boolean>) {
            state.personalInfo.isResident = action.payload;
            state.isResidencyEditMode = false;
        },

        openDriverLicenceEditMode(state) {
            state.driverLicenceIsEditMode = true;
        },
        cancelDriverLicenceEditMode(state) {
            state.driverLicenceIsEditMode = false;
        },
        updateDriverLicenceNumber(state, action: PayloadAction<string>) {
            state.personalInfo.driverLicenceNumber = action.payload;
            state.driverLicenceIsEditMode = false;
        },
    },
});

export const {
    personalDetailsSubmit,
    personalDetailsContactsEdit,
    updatePersonalDetailsEndpoints,
    getPersonalDetailsFulfilled,
    getPersonalDetailsRejected,
    getPersonalDetails,
    deletePersonalDetails,
    deletePersonalDetailsFulfilled,
    deletePersonalDetailsRejected,
    resetPersonalDetailsStatus,
    updateCheckboxState,
    openResidencyEditMode,
    cancelResidencyEditMode,
    updateResidencyState,
    openDriverLicenceEditMode,
    cancelDriverLicenceEditMode,
    updateDriverLicenceNumber,
} = personalDetailsSlice.actions;

export const personalDetailsReducer: Reducer<PersonalDetailsState, AnyAction> = personalDetailsSlice.reducer;
